import * as yup from 'yup';

export const FIELD_FIRST_NAME = 'firstName';
export const FIELD_LAST_NAME = 'lastName';
export const FIELD_MIDDLE_NAME = 'surname';
export const FIELD_PIN = 'pin';
export const FIELD_ADDRESS = 'address';
export const FIELD_PHONE = 'phone';
export const FIELD_EMAIL = 'email';
export const FIELD_PEV_UID = 'prevUid';
export const FIELD_DIRECTION = 'direction';
export const FIELD_REGION = 'region';
export const FIELD_DISTRICT = 'district';

export const ApplicationEditValidationForm = yup.object().shape({
  [FIELD_FIRST_NAME]: yup.string().required('error.required').trim(),
  [FIELD_LAST_NAME]: yup.string().required('error.required').trim(),
  [FIELD_MIDDLE_NAME]: yup.string().required('error.required').trim(),
  [FIELD_PIN]: yup.string().length(14).required('error.required').trim(),
  [FIELD_ADDRESS]: yup.string().required('error.required').trim(),
  [FIELD_PHONE]: yup.string().required('error.required').trim(),
  [FIELD_EMAIL]: yup.string().required('error.required').trim(),
  [FIELD_DIRECTION]: yup.string().required('error.required').trim(),
  [FIELD_REGION]: yup.string().required('error.required').trim(),
  [FIELD_DISTRICT]: yup.string().required('error.required').trim(),
});
